import type { OrderServiceCoreServicesKinds } from 'constants/_types/OrderServiceCoreServicesKinds';

export const replaceDashWithUnderscore = <T extends OrderServiceCoreServicesKinds | string = OrderServiceCoreServicesKinds>(
  kindWithDash: T,
) => {
  const kindWithUnderscore = (kindWithDash as string).replace('-', '_') as T;

  return kindWithUnderscore;
};
